const getBorderMock = (theme) => `
  &:after {
    border-radius: 5px;
    background-color: transparent;
    transition: border ${theme.transitions.duration.fast} linear;
    border: 1px solid transparent;
    content: '';
    display: block;
    position: absolute;
    top: -1px;
    left: -1px;
    right: -1px;
    bottom: -1px;
    pointer-events: none;
  }`;
const getBorderMockJSS = (theme) => ({
    ':after': {
        borderRadius: 5,
        backgroundColor: 'transparent',
        transition: `border ${theme.transitions.duration.fast} linear`,
        border: '1px solid transparent',
        content: `''`,
        display: 'block',
        position: 'absolute',
        top: -1,
        left: -1,
        right: -1,
        bottom: -1,
        pointerEvents: 'none',
    },
});

export { getBorderMock, getBorderMockJSS };
//# sourceMappingURL=getBorderMock.js.map
